import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { GadmGeoJSONResponse, GadmL0Response } from './types/gadm';

// Define a service using a base URL and expected endpoints
export const staticService = createApi({
  reducerPath: 'staticService',
  keepUnusedDataFor: 1800, // 30 minutes
  baseQuery: fetchBaseQuery({ baseUrl: window.location.origin }),
  endpoints: (builder) => ({
    getGADMData: builder.query<GadmGeoJSONResponse, void>({
      query: () => ({
        method: 'GET',
        url: '/gadm_static_geoms.geojson'
      })
    }),
    getL0Countries: builder.query<GadmL0Response, void>({
      query: () => ({
        method: 'GET',
        url: '/gadm_l0.json'
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  // \n
  useGetGADMDataQuery,
  useGetL0CountriesQuery
} = staticService;
